export default {
  email: (permalink) => {
    const url = permalink || window.location.href
    window.open(
      `http://api.addthis.com/oexchange/0.8/forward/email/offer?url=${encodeURIComponent(url)}`,
      'share',
      'status=no,toolbar=no,location=no,directories=no,menubar=no'
    )
  },

  facebook: (permalink) => {
    const url = permalink || window.location.href
    if (window.FB) {
      window.FB.ui({
        method: 'share',
        href: url,
      })
    } else {
      window.open(
        `https://facebook.com/sharer.php?u=${encodeURIComponent(url)}`,
        'share',
        'status=no,toolbar=no,location=no,directories=no,menubar=no'
      )
    }
  },

  twitter: (permalink, title)=> {
    const url = permalink || window.location.hrefs
    var text = title
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
      'share',
      'status=no,toolbar=no,location=no,directories=no,menubar=no'
    )
  },

  whatsapp: (permalink, title) => {
    const url = permalink || window.location.href
    var text = title
    const encodedUrl = `whatsapp://send?text=${encodeURIComponent(text)}%20${encodeURIComponent(url)}`
    window.location = encodedUrl
  },

  googlePlus: (permalink) => {
    const url = permalink || window.location.href;
    window.open(
      `https://plus.google.com/share?url=${encodeURIComponent(url)}`,
      'share',
      'status=no,toolbar=no,location=no,directories=no,menubar=no'
    )
  }
}
